import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useCrm } from "../shared";
import { useCrmSocket } from "../socket";

// Realtime toast for the owner when a WhatsApp reply / transfer lands; click opens the conversation.
export function WaToaster() {
  const { user } = useCrm();
  const navigate = useNavigate();
  useCrmSocket("wa:notify", (d) => {
    if (!d || d.user_id !== user?.id) return;
    toast.message("WhatsApp", { description: d.text, action: { label: "Open", onClick: () => navigate(`/crm/whatsapp?tab=inbox&c=${d.conversation_id}`) } });
    if (typeof Notification !== "undefined" && Notification.permission === "granted" && document.hidden) new Notification("WhatsApp reply", { body: d.text });
  });
  return null;
}
